/* eslint-disable ember/no-empty-glimmer-component-classes */
import Component from '@glimmer/component';

// the empty class definition is necessary to be able to look up this component
// via `component:changebee-wallet-modal`
export default class ChargebeeWalletModal extends Component {}
